var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data",style:(_vm.styles)},[_c('i',{staticClass:"iconfont icon-wushuju"}),_c('p',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }